var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGbp = function SvgGbp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 39.5,
    height: 39.5,
    rx: 19.75,
    stroke: "#080808",
    strokeOpacity: 0.08,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40C31.0459 40 40.0002 31.0457 40.0002 20C40.0002 8.9543 31.0459 0 20.0002 0C8.95455 0 0.000244141 8.9543 0.000244141 20C0.000244141 31.0457 8.95455 40 20.0002 40Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13435 7.82385C2.56334 9.86784 1.37873 12.2237 0.688965 14.783H11.0935L4.13435 7.82385Z",
    fill: "#012169"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3111 14.783C38.6214 12.2238 37.4367 9.86796 35.8657 7.82397L28.9067 14.783H39.3111Z",
    fill: "#012169"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.688965 25.2178C1.37881 27.777 2.56342 30.1329 4.13436 32.1768L11.0933 25.2178H0.688965Z",
    fill: "#012169"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1764 4.13468C30.1324 2.56366 27.7766 1.37905 25.2173 0.689209V11.0937L32.1764 4.13468Z",
    fill: "#012169"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82349 35.8658C9.86747 37.4368 12.2233 38.6214 14.7825 39.3112V28.9069L7.82349 35.8658Z",
    fill: "#012169"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7825 0.689209C12.2233 1.37905 9.86739 2.56366 7.82349 4.1346L14.7825 11.0936V0.689209Z",
    fill: "#012169"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2173 39.3112C27.7765 38.6214 30.1324 37.4368 32.1763 35.8658L25.2173 28.9069V39.3112Z",
    fill: "#012169"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9067 25.2178L35.8657 32.1768C37.4367 30.1329 38.6214 27.777 39.3111 25.2178H28.9067Z",
    fill: "#012169"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.831 17.3913H22.6091H22.609V0.169297C21.755 0.058125 20.8844 0 20.0002 0C19.1159 0 18.2455 0.058125 17.3916 0.169297V17.3912V17.3913H0.169541C0.0583692 18.2452 0.000244141 19.1159 0.000244141 20C0.000244141 20.8843 0.0583692 21.7548 0.169541 22.6087H17.3914H17.3915V39.8307C18.2455 39.9419 19.1159 40 20.0002 40C20.8844 40 21.755 39.942 22.6089 39.8307V22.6088V22.6087H39.831C39.9421 21.7548 40.0002 20.8843 40.0002 20C40.0002 19.1159 39.9421 18.2452 39.831 17.3913Z",
    fill: "#E4002B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2173 25.2176L34.142 34.1423C34.5524 33.732 34.944 33.303 35.3176 32.8583L27.6768 25.2175H25.2173V25.2176Z",
    fill: "#E4002B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7827 25.2175H14.7825L5.85791 34.1421C6.26822 34.5526 6.69721 34.9442 7.14189 35.3178L14.7827 27.6768V25.2175Z",
    fill: "#E4002B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7827 14.7827V14.7826L5.858 5.85779C5.44753 6.2681 5.05597 6.69708 4.68237 7.14177L12.3232 14.7826H14.7827V14.7827Z",
    fill: "#E4002B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2173 14.7828L34.142 5.85792C33.7317 5.44745 33.3028 5.05589 32.8581 4.68237L25.2173 12.3232V14.7828Z",
    fill: "#E4002B"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGbp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "GBP.adfc2c4312e3678e24309c2f5137368f.svg";